import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
// import moment from 'utils/moment'
import "react-big-calendar/lib/css/react-big-calendar.css";

// icn
import { ReactComponent as SettingIcn } from "../../../../../Assets/Images/icn/setting.svg";
import { ReactComponent as PlusIcn } from "../../../../../Assets/Images/icn/plus.svg";
import { Button, Dropdown } from "react-bootstrap";
import BookAppointmentPop from "pages/SideTabs/MyClients/Component/Modal/BookAppointmentPop";
import AddBlockPop from "./Modals/AddBlockPop";
import AppointmentDetailPopup from "./Modals/AppointmentDetailPopup";
import BlockDetailsPopup from "./Modals/BlockDetailsPopup";
import { FULL_NAME, utcTimestamp_, timeZoneFormat_, formatAppointmentDateTimezone, isPastDateTime } from "helpers/common";
import { updateSchedulerSetting_ } from "store/services/appointmentService";
import momentTZ from "moment-timezone";
import EventDetailPopup from "./Modals/EventDetailPopup";



const AppointmentCalender = ({
  scheduleSec,
  setScheduleSec,
  setSchedulerType,
  handleChangeBlock_,
  blockfields,
  submitBlockTimeData,
  BlockAdd,
  setBlockAdd,
  accountList,
  validationErrors,
  buttonDisable_,
  appointmentTypeList,
  timeZoneListing,
  appointmentBookingList,
  setEditValueSetting,
  setStepType,
  setBookApp,
  calendarBlocks,
  schedulerTimezone,
  schedulerBlockDatesSetting,
  accountSettingList,
  handleRangeChange,
  calendarBusyEvents
}) => {
  

  const [bookAppointment, setBookAppointment] = useState("");
  const [showAppointmentDetailPopup, setShowAppointmentDetailPopup] = useState(false);
  const [showBlockDetailPopup, setShowBlockDetailPopup] = useState(false);
  const [currentAppointmentDetails, setCurrentAppointmentDetails] = useState(null);
  const [currentBlockDetails, setCurrentBlockDetails] = useState(null);
  const [showEventDetailPopup, setShowEventDetailPopup] = useState(false);
  const [currectEventDetails, setCurrentEventDetails] = useState(null);
  const [events, setEvents] = useState([]);
  const [view, setView] = useState('month');
  const [date, setDate] = useState(new Date());

  // const momentObj = getMoment(schedulerTimezone);
  // const localizer = customMomentLocalizer(momentTZ, schedulerTimezone);
  // const momentBound = partial(momentTZ.tz, _, schedulerTimezone);

  const localizer = momentLocalizer(momentTZ);  

  // set default calendar timezone
  // useEffect(() => {
  //   if(!schedulerTimezone) {
  //     return
  //   }
  //   console.log("Set timezone to", schedulerTimezone);
  //   momentTZ.tz.setDefault(schedulerTimezone);

  //   return () => {
  //     console.log("Set timezone to default");
  //     momentTZ.tz.setDefault();
  //   }
  // }, [schedulerTimezone])

  // open appointment details popup
  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    let appointmentId = searchParams.get("apptId");
    if(appointmentId && appointmentBookingList) {
      openAppointmentDetailsPopup(appointmentId);
    }
  }, [appointmentBookingList])

  useEffect(() => {
    let appointments = [];
    if(appointmentBookingList?.length) {
      appointments = appointmentBookingList.map(appointment => {
        let clientFullName = `${FULL_NAME(appointment.first_name, appointment.last_name)}`;
        const appointmentTimezone = appointment.appointment_timezone;
        // const startTime = momentTZ(appointment.start_time).toDate();
        // const endTime = momentTZ(appointment.end_time).toDate();
        const startdate = momentTZ(appointment.start_time).tz(schedulerTimezone);
        const enddate = momentTZ(appointment.end_time).tz(schedulerTimezone);
        const startTime = new Date(startdate.year(), startdate.month(), startdate.date(), startdate.hour(), startdate.minute(), 0);
        const endTime = new Date(enddate.year(), enddate.month(), enddate.date(), enddate.hour(), enddate.minute(), 0);
        // console.log("startTime", startTime)

        return {
          id: appointment.id,
          title: `${appointment.title}: ${clientFullName}, ${formatAppointmentDateTimezone(appointment.start_time, schedulerTimezone, "dddd MMMM DD, YYYY h:mm a")} - ${formatAppointmentDateTimezone(appointment.end_time, schedulerTimezone, "dddd MMMM DD, YYYY h:mm a")}`,
          start:  startTime,
          end: endTime,
          type: "appointment",
          // appointmentStatus: appointment.status,
        }
      })
    }

    let busyEvents = [];
    if(calendarBusyEvents?.length) {
      busyEvents = calendarBusyEvents.map(event => {
        const startdate = momentTZ(event?.start?.dateTime).tz(schedulerTimezone);
        const enddate = momentTZ(event?.end?.dateTime).tz(schedulerTimezone);
        const startTime = new Date(startdate.year(), startdate.month(), startdate.date(), startdate.hour(), startdate.minute(), 0);
        const endTime = new Date(enddate.year(), enddate.month(), enddate.date(), enddate.hour(), enddate.minute(), 0);
        // console.log("startTime", startTime)

        return {
          id: event.id,
          title: `Google Calendar: ${event.summary}: ${formatAppointmentDateTimezone(event?.start?.dateTime, schedulerTimezone, "dddd MMMM DD, YYYY h:mm a")} - ${formatAppointmentDateTimezone(event?.end?.dateTime, schedulerTimezone, "dddd MMMM DD, YYYY h:mm a")}`,
          start:  startTime,
          end: endTime,
          type: "googleEvent",
          rawData: event
        }
      })
    }

    let blockedTimes = [];
    if(calendarBlocks?.length) {
      blockedTimes = calendarBlocks.map((block, i) => {
        let blockTimezone = block.timezone;
        let startTime;
        let endTime;

        if(block.full_day_block) {
          // if the block is full day block
          startTime = momentTZ(block.from_date).set('hour', 0).set("minute", 1).toDate();
          endTime = momentTZ(block.to_date).set('hour', 23).set("minute", 59).toDate();
        } else {
          // if the block is not full day block, then set the block timezone to date object
          startTime = momentTZ(block.from_date).tz(blockTimezone, true).toDate();
          endTime = momentTZ(block.to_date).tz(blockTimezone, true).toDate();
        }

        return {
          title: "Block",
          start:  startTime,
          end: endTime,
          type: "block",
          isAllDay: block.full_day_block,
          key: i,
        }
      })
    }

    const events = [
      ...appointments,
      ...blockedTimes,
      ...busyEvents,
    ]

    // console.log(events, "events");
    setEvents(events);
  }, [appointmentBookingList, calendarBlocks])

  const handleScheduleSec = () => {
    setScheduleSec(!scheduleSec);
    setSchedulerType(true)
    setStepType(true)
  };
 

  const eventStyleGetter = (event, start, end, isSelected) => {
    const isCompleted = event.appointmentStatus === "completed";
    const color = event.type == "googleEvent" ? "#0A4049" : (isCompleted ? "#198754" : event.color);
    const style = {
      backgroundColor: color,
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
      width: "100%",
      padding: 0,
    };
    return {
      style,
    };
  };

  const handleBookAppointment = () => {
    setBookAppointment(!bookAppointment);
  };

  const handleBlockAdd = () => setBlockAdd(!BlockAdd);

  const handleEventSelect = (event) => {
    if(event.type == "appointment") {
      openAppointmentDetailsPopup(event.id);
    } else if(event.type == "block") {
      openBlockDetailsPopup(event);
    } else if(event.type == "googleEvent") {
      openEventDetailsPopup(event.rawData);
    }
  }

  const openAppointmentDetailsPopup = (apptId) => {
    const appointment = appointmentBookingList.find(appointment => appointment.id == apptId);
    if(appointment) {
      setCurrentAppointmentDetails(appointment);
      setShowAppointmentDetailPopup(true);
    }
  }

  const openBlockDetailsPopup = (eventData) => {
    setCurrentBlockDetails(eventData);
    setShowBlockDetailPopup(true);
  }

  const openEventDetailsPopup = (eventData) => {
    setCurrentEventDetails(eventData);
    setShowEventDetailPopup(true);
  }

  const Event = (props) => {
    // console.log("props", props)
    const {event} = props
    return (
      <div className={`calendar-event ${event.type}`}>
        {event.title}
      </div>
    )
  }

  // Calculate initial visible range manually on mount or view change
  const getVisibleRange = (date, view) => {
    let start, end;

    switch (view) {
      case 'month':
        start = momentTZ(date).startOf('month').startOf('week').toDate();
        end = momentTZ(date).endOf('month').endOf('week').toDate();
        break;
      case 'week':
        start = momentTZ(date).startOf('week').toDate();
        end = momentTZ(date).endOf('week').toDate();
        break;
      case 'work_week':
        start = momentTZ(date).startOf('week').add(1, 'day').toDate(); // Monday
        end = momentTZ(date).startOf('week').add(5, 'days').toDate();  // Friday
        break;
      case 'day':
        start = momentTZ(date).startOf('day').toDate();
        end = momentTZ(date).endOf('day').toDate();
        break;
      default:
        return null;
    }

    return { start, end };
  };

  useEffect(() => {
    handleRangeChange(getVisibleRange(date, view));
  }, [date, view]);

  return (
    <>
      <BookAppointmentPop
        bookAppointment={bookAppointment}
        setBookAppointment={setBookAppointment}
        appointmentTypeList={appointmentTypeList}
        accountList={accountList}
        timeZoneListing={timeZoneListing}
        setBookApp={setBookApp}
        schedulerTimezone={schedulerTimezone}
      />
      <AddBlockPop
        BlockAdd={BlockAdd}
        setBlockAdd={setBlockAdd}
        blockfields={blockfields}
        handleChangeBlock_={handleChangeBlock_}
        submitBlockTimeData={submitBlockTimeData}
        accountList={accountList}
        validationErrors={validationErrors}
        buttonDisable_={buttonDisable_}
      />
      <AppointmentDetailPopup
        showPopup={showAppointmentDetailPopup}
        setShowPopup={setShowAppointmentDetailPopup}
        details={currentAppointmentDetails}
        setBookApp={setBookApp}
        schedulerTimezone={schedulerTimezone}
      />
      <EventDetailPopup
        showPopup={showEventDetailPopup}
        setShowPopup={setShowEventDetailPopup}
        details={currectEventDetails}
        schedulerTimezone={schedulerTimezone}
      />
      <BlockDetailsPopup
        showPopup={showBlockDetailPopup}
        setShowPopup={setShowBlockDetailPopup}
        details={currentBlockDetails}
        calendarBlocks={calendarBlocks}
        schedulerBlockDatesSetting={schedulerBlockDatesSetting}
        timezone={schedulerTimezone}
        accountSettingList={accountSettingList}
      />
      <div className="CalenderWrpper">
        <div className="top d-flex align-items-center justify-content-between gap-10 mb-3">
          {/* <Button className="d-flex align-items-center justify-content-center commonBtn btnSm">
            <span className="icn me-2">
              <PlusIcn />
            </span>{" "}
            Add
          </Button> */}
          <Dropdown>
            <Dropdown.Toggle
              className="d-flex align-items-center justify-content-center commonBtn btnSm noAfter"
              id="dropdown-basic"
            >
              <span className="icn me-2">
                <PlusIcn />
              </span>{" "}
              Add
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={handleBlockAdd}>New Block</Dropdown.Item>
              <Dropdown.Item onClick={handleBookAppointment}>
                New Appointment
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            onClick={handleScheduleSec}
            className="d-flex align-items-center fw-sbold justify-content-center commonBtn btnSm"
          >
            <span className="icn me-2">
              <SettingIcn />
            </span>{" "}
            Scheduler Settings
          </Button>
        </div>
        <Calendar
          localizer={localizer}
          events={events}
          eventPropGetter={eventStyleGetter}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          formats={{
            timeGutterFormat: 'HH:mm', // Adjust the time format as needed
          }}
          views={['month', 'week', 'day']}
          defaultView="month" 
          onSelectEvent={handleEventSelect}
          components={{
            event: Event,
            // month: { event: Event },
          }}
          onNavigate={(newDate) => setDate(newDate)}
          // showAllEvents
        />
      </div>
    </>
  );
};

const customMomentLocalizer = (moment, timezone) => {
  const baseLocalizer = momentLocalizer(moment);

  let localizer = {
    ...baseLocalizer,
    format: (value, format, culture) => {
      // console.log("params >>>", value, format, culture);
      if (typeof format === 'function') {
        const formattedValue = format(value, culture, localizer);
        // console.log("formattedValue >>>", formattedValue);
        return (formattedValue && typeof formattedValue === "string") ? formattedValue : moment(formattedValue).tz(timezone).format();
      }

      if (typeof format === 'string') {
        return moment(value).tz(timezone).format(format);
      }

      return moment(value).tz(timezone).format(); // Default formatting
    },
  };

  return localizer;
};


export default AppointmentCalender;
